/* eslint-disable @typescript-eslint/consistent-type-assertions */
import { useMemo } from 'react';
import { createRouterSelector } from '@atlassian/react-resource-router/src/controllers/router-store/index.tsx';
import { useAutomationLimitBannerState, useAutomationLimitBannerActions } from '../store/index.tsx';
import { BANNER_NAME } from '../../common/constants.tsx';

export const useBannerAutomationLimitAwarenessState = () => {
	const state = useAutomationLimitBannerState();
	const actions = useAutomationLimitBannerActions();

	return {
		isDismissed: state.isDismissed,
		height: state.height,
		isLoading: state.isLoading,
		actions,
	};
};

const useIsJiraValidPath = createRouterSelector(({ location }): boolean => {
	return location.pathname.includes('/jira/software');
});

const useIsJiraServiceDeskValidPath = createRouterSelector(({ location }): boolean => {
	return location.pathname.includes('/jira/servicedesk');
});

export const useBannerAutomationLimitAwareness = () => {
	const state = useAutomationLimitBannerState();
	const isJiraValidPath = useIsJiraValidPath();
	const isJiraServiceDeskValidPath = useIsJiraServiceDeskValidPath();

	return useMemo(
		() => ({
			isEnabled:
				(isJiraValidPath || isJiraServiceDeskValidPath) && !state.isDismissed && !state.isLoading,
			name: BANNER_NAME as string,
			height: state.isLoading || state.isDismissed ? 0 : state.height,
		}),
		[state.isDismissed, state.isLoading, state.height, isJiraValidPath, isJiraServiceDeskValidPath],
	);
};
